<template>
  <el-dialog
    v-model="dialogVisible"
    title="证书下载"
    width="550px"
    :before-close="handleClose"
  >
    <div>
      <div class="zhengshumodel">
        <el-image style="width:200px;height:283px" :preview-src-list="srcList" :src="require('@/assets/img/zhengshu/model-fbzs.jpg')"></el-image>
        <div class="zhengshumodel-title">证书样式（点击查看原图）</div>
      </div>
      <el-form :inline="true" :model="form" label-width="120px">
        <el-form-item label="请输入手机号">
          <el-input v-model="form.tel" />
        </el-form-item>
        <el-form-item label="请输入验证码">
          <el-input v-model="form.code" />
          <el-button type="success" style="margin-left: 10px" @click="fscode"
            >获取验证码</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <!-- <el-button type="warning" @click="dialogTableVisible=true">查看证书样式</el-button> -->
        <el-button
          type="primary"
          @click="
            handleClose();
            onSubmit();
          "
        >
          下载证书
        </el-button>
      </span>
    </template>
    <!-- <el-dialog v-model="dialogTableVisible" title="证书样式">
      <div>效果</div>
    </el-dialog> -->
  </el-dialog>
</template>

<script setup>
import { get } from "@/utils/index";
import { ref, reactive, defineProps, watch, defineEmits } from "vue";
// router
import { useRouter } from "vue-router";
const router = useRouter();
import { ElMessage } from "element-plus";
// 父组件传递值
const props = defineProps({
  dVisible: {
    type: Boolean,
  },
});
// 显示
let dialogVisible = ref(false);
// let dialogTableVisible = ref(false)
// 文章id
const wenzid = router.currentRoute.value.query.wzid;
// form
let form = reactive({
  tel: "",
  code: "",
});
// 预览图
const srcList=[require('@/assets/img/zhengshu/model-fbzs.jpg')]

// 监听父元素传递值变化更改显示状态
watch(
  () => props.dVisible,
  (newVal, oldVal) => {
    dialogVisible.value = props.dVisible;
  }
);
// 定义向父组件传值
const emit = defineEmits(["clickClose"]);
// 关闭时执行
const handleClose = () => {
  emit("clickClose", false);
};
// 发送验证码
const fscode = () => {
  if (form.tel.trim() === "") {
    ElMessage({
      message: "请输入手机号",
      type: "info",
    });
    return false;
  }
  get("/api/NewsPaper/SendPhoneCode", {
    id: wenzid,
    p: form.tel,
  }).then((res) => {
    ElMessage({
      message: res.msg,
      type: "success",
    });
  });
};
// 提交
const onSubmit = () => {
  get("/api/NewsPaper/GetArticleCertificate", {
    id: wenzid,
    phone: form.tel,
    code: form.code,
  }).then((res) => {
    window.open(
      `http://114.117.204.133:8004/api/NewsPaper/DownloadCertificate?id=${wenzid}&phone=${form.tel}&code=${form.code}`
    );
  });
};
</script>

<style scoped>
::v-deep .el-form-item__content {
  flex-wrap: nowrap;
  width: 350px;
}
.zhengshumodel{
  width: 100%;
  height: 343px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.zhengshumodel-title{
  text-align: center;
  padding: 10px 0 30px 0;
}
</style>
